var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.87283 8.81592V4.85551H6.80621V8.81592H5.87283ZM6.3421 4.29342C6.19427 4.29342 6.06707 4.24444 5.9605 4.14646C5.85392 4.04676 5.80064 3.92729 5.80064 3.78806C5.80064 3.64711 5.85392 3.52764 5.9605 3.42966C6.06707 3.32997 6.19427 3.28012 6.3421 3.28012C6.49165 3.28012 6.61885 3.32997 6.7237 3.42966C6.83027 3.52764 6.88356 3.64711 6.88356 3.78806C6.88356 3.92729 6.83027 4.04676 6.7237 4.14646C6.61885 4.24444 6.49165 4.29342 6.3421 4.29342Z",
    fill: "currentcolor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.42944,
    cy: 6.5354,
    r: 5.92163,
    stroke: "currentcolor",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.82a4119ec242bb3f5aed2d26fa81b3a6.svg";
export { ForwardRef as ReactComponent };